import * as types from './constants';

const initialState = {
  data: {},
  loading: false,
  errors_api: {}
};

const actions = {
  // Verify Merchant
  [types.VERIFY_MERCHANT_REQUEST]: state => {
    const data = {
      ...state,
      loading: true,
      errors_api: {}
    };

    return { ...data };
  },

  [types.VERIFY_MERCHANT_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      data: payload
    };

    return { ...data };
  },

  [types.VERIFY_MERCHANT_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.VERIFY_MERCHANT_RESET]: state => {
    const data = {
      ...state,
      ...initialState
    };

    return { ...data };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};

